import { NavigationEnd, ResolveFn, Router } from "@angular/router";
import { inject } from "@angular/core";
import { WsManagerService } from "../services/api-services/ws-manager.service";
import { catchError, from, map, of, window } from "rxjs";
import { ApiDemoExecutionService } from "../services/api-demos/api-demo-execution.service";

export const wsResolver: ResolveFn<boolean> = (route, state) => {
	const wsManager = inject(WsManagerService);
	const api = inject(ApiDemoExecutionService);
	globalThis.location.href.includes("demo-free") ? api.setAuthorizationFree(true) : api.setAuthorizationFree(false);
	return from(wsManager.establishConnection()).pipe(
		map(() => true),
		catchError(() => of(true)),
	);
};
